"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcTitleQuickAccessed = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3 2C3 1.44772 3.44772 1 4 1H16C16.5523 1 17 1.44772 17 2V19L10.4798 15.4346C10.1808 15.2711 9.81919 15.2711 9.52023 15.4346L3 19V2Z" }) })));
exports.default = IcTitleQuickAccessed;
